var _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon247Support(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 0.5C46.2924 0.5 59.5 13.7076 59.5 30C59.5 46.2924 46.2924 59.5 30 59.5C13.7076 59.5 0.5 46.2924 0.5 30C0.5 13.7076 13.7076 0.5 30 0.5Z",
    stroke: "url(#paint0_linear_18_2560)",
    strokeOpacity: 0.41
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14258 30.0001C5.14258 16.2719 16.2715 5.14294 29.9997 5.14294C43.7279 5.14294 54.8569 16.2719 54.8569 30.0001C54.8569 43.7283 43.7279 54.8572 29.9997 54.8572C16.2715 54.8572 5.14258 43.7283 5.14258 30.0001Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5.64294C43.4519 5.6431 54.3564 16.5484 54.3564 30.0004C54.3563 43.4522 43.4519 54.3567 30 54.3568C16.548 54.3568 5.64273 43.4523 5.64258 30.0004C5.64258 16.5483 16.5479 5.64294 30 5.64294Z",
    stroke: "url(#paint1_linear_18_2560)",
    strokeOpacity: 0.41
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2560)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 24,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 18H18V42H42V18Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 36.4297H31L26.55 39.3897C25.89 39.8297 25 39.3597 25 38.5597V36.4297C22 36.4297 20 34.4297 20 31.4297V25.4297C20 22.4297 22 20.4297 25 20.4297H35C38 20.4297 40 22.4297 40 25.4297V31.4297C40 34.4297 38 36.4297 35 36.4297Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 30.1094C29.5898 30.1094 29.2498 29.7694 29.2498 29.3594V29.1494C29.2498 27.9894 30.0998 27.4194 30.4198 27.1994C30.7898 26.9494 30.9098 26.7794 30.9098 26.5194C30.9098 26.0194 30.4998 25.6094 29.9998 25.6094C29.4998 25.6094 29.0898 26.0194 29.0898 26.5194C29.0898 26.9294 28.7498 27.2694 28.3398 27.2694C27.9298 27.2694 27.5898 26.9294 27.5898 26.5194C27.5898 25.1894 28.6698 24.1094 29.9998 24.1094C31.3298 24.1094 32.4098 25.1894 32.4098 26.5194C32.4098 27.6594 31.5698 28.2294 31.2598 28.4394C30.8698 28.6994 30.7498 28.8694 30.7498 29.1494V29.3594C30.7498 29.7794 30.4098 30.1094 29.9998 30.1094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 32.5996C29.58 32.5996 29.25 32.2596 29.25 31.8496C29.25 31.4396 29.59 31.0996 30 31.0996C30.41 31.0996 30.75 31.4396 30.75 31.8496C30.75 32.2596 30.42 32.5996 30 32.5996Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2560",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2560",
    x1: 29.9997,
    y1: 5.14294,
    x2: 29.9997,
    y2: 54.8572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon247Support);
export default __webpack_public_path__ + "static/media/icon-24_7-support.9dddf09479ad80d9e2ef2d5ed160341d.svg";
export { ForwardRef as ReactComponent };